export default __webpack_public_path__ + "static/backgroundWhyJoiningUs-bf42c14689471d6f0adc76b90d6c0ed8.svg";